<template>
    <div class="d-flex flex-wrap">
        <!-- Кнопка импорта карт из буфера обмена -->
        <b-button v-b-tooltip.hover :title="$t('route.import')" class="mr-1" size="sm" variant="outline-info"
            @click="$emit('import-clipboard')">
            <b-icon icon="clipboard" font-scale="1" />
        </b-button>
    
        <!-- Кнопка добавления карт по области -->
        <b-button v-b-tooltip.hover :title="areaSelectionActive ? 'Cancel area selection' : 'Select charts by area on map'"
            class="mr-1" size="sm" :variant="areaSelectionActive ? 'warning' : 'outline-info'"
            @click="$emit('toggle-area-selection')">
            <b-icon :icon="areaSelectionActive ? 'x-circle' : 'bounding-box'" font-scale="1" />
        </b-button>
    
        <!-- Кнопка добавления карт по маршруту -->
        <b-button v-b-tooltip.hover :title="hasActiveRoute ? 'Select charts by route' : 'Build a route first'" class="mr-1"
            size="sm" :variant="hasActiveRoute ? 'outline-info' : 'outline-secondary'" :disabled="!hasActiveRoute"
            @click="$emit('select-charts-by-route')">
            <b-icon icon="signpost-2" font-scale="1" />
        </b-button>
    
        <!-- Кнопка очистки корзины -->
        <b-button v-if="!isEmptyCart" v-b-tooltip.hover title="Clear cart" size="sm" variant="outline-danger"
            @click="$emit('clear-cart')">
            <b-icon icon="trash" font-scale="1" />
        </b-button>
    </div>
</template>

<script>
export default {
  name: 'ActionButtons',
  props: {
    areaSelectionActive: {
      type: Boolean,
      default: false
    },
    hasActiveRoute: {
      type: Boolean,
      default: false
    },
    isEmptyCart: {
      type: Boolean,
      default: true
    }
  }
}
</script>
